import React, { useState } from 'react';

const TestimonialsSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  
  const testimonials = [
    {
      id: 1,
      name: 'Ravi',
      role: 'Cloud Engineer',
      quote: 'The hands-on training gave me real-world skills I could apply immediately. In just 2 months, I landed a much better role thanks to the solid foundation and confidence I gained.'
    },
    {
      id: 2,
      name: 'Anjali',
      role: 'DevOps Engineer',
      quote: 'Super practical training with real Devops tools. I landed a better role as a Devops Engineer in just 2 months thanks to the solid foundation I got here.'
    },
    {
      id: 3,
      name: 'Manikiran',
      role: 'Software Engineer',
      quote: 'The comprehensive curriculum and expert mentoring helped me transition to a new tech role with confidence. The skills I gained were immediately applicable to real-world challenges.'
    },
    {
      id: 4,
      name: 'Sundar',
      role: 'Data Analyst',
      quote: 'After completing the program, I was able to apply my new skills immediately. The practical approach to learning made all the difference in my career growth.'
    },
    {
      id: 5,
      name: 'Rajashekar',
      role: 'Full Stack Developer',
      quote: 'The hands-on projects and personalized guidance from experienced mentors helped me land my dream job within months of completing the program.'
    }
  ];
  
  const nextTestimonial = () => {
    setCurrentTestimonial(prev => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };
  
  const prevTestimonial = () => {
    setCurrentTestimonial(prev => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };
  
  const goToTestimonial = (index) => {
    setCurrentTestimonial(index);
  };
  
  return (
    <section className="testimonials-section" id="testimonials">
      <div className="testimonials-content">
        <h2 className="section-title">Testimonials</h2>
        <div className="title-underline"></div>
        
        <p className="section-description">
          Hear from our learners who transformed their careers with our practical, hands-on training. From career switches to promotions, see how SkillRaiz made a real difference.
        </p>
        
        <div className="testimonials-slider">
          <div className="testimonial-cards-container">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className={`testimonial-card ${index === currentTestimonial ? 'active' : ''}`}
                style={{ 
                  display: index === currentTestimonial ? 'block' : 'none',
                  backgroundColor: '#E6F4FA',
                  borderRadius: '12px',
                  padding: '30px',
                  position: 'relative',
                  maxWidth: '800px',
                  margin: '0 auto'
                }}
              >
                <h3 
                  style={{ 
                    color: '#0077B6', 
                    fontSize: '24px',
                    margin: '0 0 8px 0'
                  }}
                >
                  {testimonial.name}
                </h3>
                <p 
                  style={{ 
                    color: '#1E5631', 
                    fontSize: '16px',
                    fontWeight: 'bold',
                    margin: '0 0 20px 0'
                  }}
                >
                  {testimonial.role}
                </p>
                <p 
                  style={{ 
                    color: '#333', 
                    fontSize: '16px',
                    lineHeight: '1.6',
                    margin: '0'
                  }}
                >
                  {testimonial.quote}
                </p>
                <div 
                  style={{ 
                    position: 'absolute', 
                    top: '20px', 
                    right: '30px',
                    display: 'flex',
                    transform: 'rotate(180deg)'
                  }}
                >
                  <svg width="55" height="45" viewBox="0 0 72 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M36 0C36 0 10 0 10 30V60H40V30H20C20 30 20 20 30 20H36V0Z" fill="#E9813A" rx="5" ry="5"/>
                    <path d="M68 0C68 0 42 0 42 30V60H72V30H52C52 30 52 20 62 20H68V0Z" fill="#E9813A" rx="5" ry="5"/>
                  </svg>
                </div>
              </div>
            ))}
          </div>
          
          <div 
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '20px',
              position: 'relative'
            }}
          >
            <div style={{ display: 'flex', gap: '10px', margin: '0 auto' , paddingTop: '30px' }}>
              {testimonials.map((_, index) => (
                <button 
                  key={index} 
                  onClick={() => goToTestimonial(index)}
                  style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: index === currentTestimonial ? '#F4A261' : '#E5E5E5',
                    cursor: 'pointer',
                    padding: '0'
                  }}
                />
              ))}
            </div>
            
            <div style={{ display: 'flex', gap: '10px', position: 'absolute', right: '0' }}>
              <button 
                onClick={prevTestimonial}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0'
                }}
              >
                <div 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '50px',
                    height: '50px',
                    borderRadius: '20px',
                    backgroundColor: 'white',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15 18L9 12L15 6" stroke="#E9813A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </button>
              
              <button 
                onClick={nextTestimonial}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: '0'
                }}
              >
                <div 
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '50px',
                    height: '50px',
                    borderRadius: '20px',
                    backgroundColor: '#E9813A',
                    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)'
                  }}
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 6L15 12L9 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection; 